// Set of generic helper functions
// ------------------------------------------------------

var h = {

  // Get offset position of supplied element relative to the document
  // ------------------------------------------------------
  offset: function(el) {
    var rect = el.getBoundingClientRect(),

    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    return {
      top: rect.top + scrollTop, left: rect.left + scrollLeft
    };
  },

  isDescendant: function(parent, child) {
    var node = child.parentNode;
      while (node !== null) {
         if (node == parent) {
             return true;
         }
         node = node.parentNode;
      }
    return false;
  },

  getCoords: function(elem) {
    var box = elem.getBoundingClientRect();

    var body = document.body;
    var docEl = document.documentElement;

    var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
    var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

    var clientTop = docEl.clientTop || body.clientTop || 0;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;

    var top  = box.top +  scrollTop - clientTop;
    var left = box.left + scrollLeft - clientLeft;

    return {
      top: Math.round(top),
      left: Math.round(left)
    };
  },
};

// Public
module.exports = h;